export default __webpack_public_path__ + "static/media/ic_gmx_footer.dc91de3c.svg";